"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Resolves the correct image src from the image element, respecting load speed optimizations and lazy load attributes. If no src can be resolved, returns empty string.
 * @param {HTMLImageElement} img
 * @returns {string}
 *
 * @example
 *
 * import {resolveImageSrc} from '@demant/wdh';
 *
 * someDiv.style.backgroundImage = `url(${resolveImageSrc(someImg)})`
 */
var resolveImageSrc = function resolveImageSrc(img) {
  var src = img && (img.getAttribute('data-pagespeed-high-res-src') || img.getAttribute('data-pagespeed-lazy-src') || img.src);
  return src || '';
};

var _default = resolveImageSrc;
exports["default"] = _default;